import {
  SET_TOKEN,
  USER_ACTIONS,
  AUTH_LOGOUT,
  SET_SIGNUP_FLOW,
  RESET_SIGNUP_FLOW,
} from "./actionTypes";
import { IsEmpty } from "../util/commonFunctions";
import { axiosUserManagement } from "../axios";
import { analytics, setUserProperties, setUserId } from "../analytics";
import { handleActionError } from "../util/error";

export const setToken = (token, provider) => {
  return {
    type: SET_TOKEN,
    token: token,
    provider: !IsEmpty(provider) ? provider : null,
  };
};

export const setUser = (token, isSetUserProperty) => {
  const config = {
    headers: {
      "cache-control": "no-cache",
      "content-type": "application/json",
      token: token,
    },
  };
  return (dispatch) => {
    dispatch({
      type: USER_ACTIONS.USER_PROFILE._START,
    });
    return axiosUserManagement
      .get("/subscriber/info", {
        ...config,
      })
      .then((response) => {
        const { data = {} } = response;
        setUserProperties({
          login_status: "true",
          profession_id: data.whatDoYouDo && data.whatDoYouDo.id,
          profession_name: data.whatDoYouDo && data.whatDoYouDo.name,
          investment_id: data.whereDoYouInvest && data.whereDoYouInvest.id,
          investment_name: data.whereDoYouInvest && data.whereDoYouInvest.name,
        });
        setUserId(data.id);
        dispatch({
          type: USER_ACTIONS.USER_PROFILE._SUCCESS,
          payload: { data: data },
        });
        analytics("sign_in", {
          device_os_version: window.navigator.appVersion,
        });
      })
      .catch((error) => {
        handleActionError("An error occurred while fetching subscriber info:", error);
        dispatch({
          type: USER_ACTIONS.USER_PROFILE._FAILURE,
        });
      });
  };
};

export const isPlayerLoaded = () => {
  return (dispatch) => {
    dispatch({
      type: USER_ACTIONS.PLAYER_LOADED,
    });
  };
};

export const logout = () => {
  typeof Storage !== "undefined" && localStorage.removeItem("token");
  return {
    type: AUTH_LOGOUT,
  };
};

export const setSignupFlow = () => {
  return {
    type: SET_SIGNUP_FLOW,
  };
};

export const resetSignupFlow = () => {
  return {
    type: RESET_SIGNUP_FLOW,
  };
};
